export const Permissions = {
  CanEditeEmployee: "CanEditeEmployee",
  CanEditeCompany: "CanEditeCompany",
  CanEditeExtraService: "CanEditeExtraService",
  CanEditeAwards: "CanEditeAwards",
  CanEditeAddtionals: "CanEditeAddtionals",
  CanEditeCoupons: "CanEditeCoupons",
  CanEditePromotions: "CanEditePromotions",
  CanEditeNotices: "CanEditeNotices",
  CanEditeCategories: "CanEditeCategories",
  CanEditeProducts: "CanEditeProducts",
  CanEditeCatalogItems: "CanEditeCatalogItems",
  CanEditeCombos: "CanEditeCombos",
  CanEditeServicePoints: "CanEditeServicePoints",
  CanEditeClients: "CanEditeClients",
  CanEditeOrders: "CanEditeOrders",
  CanViewProfit: "CanViewProfit",
  CanEditeFulfillment: "CanEditeFulfillment",
  CanEditeCourier: "CanEditeCourier",
  CanAnswerWhatsApp: "CanAnswerWhatsApp",
  CanEditeTimeClock: "CanEditeTimeClock",
  CanChargeTapToPay: "CanChargeTapToPay",
  CanManageChecklists: "CanManageChecklists",
  CanExecuteChecklists: "CanExecuteChecklists",
} as const

export type PermissionsType = (typeof Permissions)[keyof typeof Permissions]
